export const LOGIN = 'login';   
export const DASHBOARD = 'dashBoard'
export const USER = "user"
export const REPORTS = "reports"
export const WRAPPER = "wrapper"
export const ATTENDANCE = "attendance"

export const DOCUMENT_MASTER  ="documents"
